import { useClerk } from '@clerk/clerk-react';
import { useEffect } from 'react';
import { DoorlyLogo } from './DoorlyLogo';
import { db } from '../db/schema';
import { resetAnalytics } from '../lib/analytics';

export function LogoutPage() {
  const { signOut } = useClerk();

  useEffect(() => {
    // Purge l'identité PostHog avant le wipe — sinon les events suivants
    // (rare mais possible) seraient toujours rattachés à l'ancien userId.
    resetAnalytics();
    // Fire everything in parallel — don't let any single step block the others
    const tasks: Promise<unknown>[] = [];

    tasks.push(db.wipe().catch(() => {}));
    tasks.push(signOut().catch(() => {}));

    if (indexedDB.databases) {
      tasks.push(
        indexedDB.databases().then((dbs) => {
          for (const d of dbs) if (d.name) indexedDB.deleteDatabase(d.name);
        }).catch(() => {}),
      );
    }

    if (navigator.serviceWorker) {
      tasks.push(
        navigator.serviceWorker.getRegistrations().then((regs) => {
          for (const r of regs) r.unregister();
        }).catch(() => {}),
      );
    }

    if (caches) {
      tasks.push(
        caches.keys().then((names) => {
          for (const n of names) caches.delete(n);
        }).catch(() => {}),
      );
    }

    // Storage + cookies are sync — do them immediately
    localStorage.clear();
    sessionStorage.clear();
    const cookieNames = document.cookie.split(';').map((c) => c.split('=')[0]?.trim()).filter(Boolean);
    for (const name of [...cookieNames, '__dev_session', '__clerk_db_jwt', '__client_uat', '__session']) {
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    }

    // Redirect as soon as signOut resolves OR after 2s max
    Promise.race([
      Promise.all(tasks),
      new Promise((r) => setTimeout(r, 2000)),
    ]).finally(() => {
      // `?next=/connexion` : depuis la modale PIN « Se connecter avec mon mot
      // de passe », on renvoie directement sur l'écran de connexion vendeur.
      // Liste blanche stricte — jamais une URL libre.
      const next = new URLSearchParams(window.location.search).get('next');
      window.location.replace(next === '/connexion' ? '/connexion' : '/');
    });
  }, [signOut]);

  return (
    <div className="min-h-dvh grid place-items-center bg-bg p-4">
      <div className="text-center space-y-4">
        <DoorlyLogo variant="icon" size={48} className="mx-auto animate-pulse" />
        <p className="text-ink-mute text-body">Déconnexion…</p>
      </div>
    </div>
  );
}
